import { createSelector } from 'reselect';

export const getIsLogoUploadAllowed = subscription => subscription && subscription.plan === 'TITAN';

export const getCollection = state => state.shops.byId;
export const getList = state => state.shops.list;

export const getAll = createSelector(
  [getCollection, getList],
  (shops, list) => list.map(id => shops[id])
);
